import React, { useEffect, useState, useRef } from 'react' // <-- Добавили useRef
import styles from './DocsViewer.module.scss'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import LocalStorage from 'services/LocalStorage'
import DocsCreator from '../DocsCreator/DocsCreator'
import SigningBlock from '../SigningBlock/SigningBlock'
import { superAxiosRequest } from '../../../../axiosApi'
import './printStyle.scss'
import { useHistory } from 'react-router-dom'

const DocsViewer = (props) => {
  const [constructorState, setConstructorState] = useState({})
  const [state, setState] = useState({
    sendCode: true,
    confirmCode: false,
    success: false,
    error: { value: false, massage: '' },
    alert: { value: false, massage: '' },
    localStorageData: {},
    documentId: false,
  })

  const [isSigningModalOpen, setIsSigningModalOpen] = useState(false)
  const [qrData, setQrData] = useState(null)
  const [isSaving, setIsSaving] = useState(false)

  const contentWrapperRef = useRef(null)

  const data = LocalStorage.get('ud')
  const id = +props.match.params.id
  const history = useHistory()

  const uploadJson = (jsonData) => {
    let lastName = data.user_data.profile.last_name
      ? data.user_data.profile.last_name
      : ''
    let firstName = data.user_data.profile.first_name
      ? `${data.user_data.profile.first_name[0]}.`
      : ''
    let fatherName = data.user_data.profile.father_name
      ? `${data.user_data.profile?.father_name[0]}.`
      : ''

    Object.keys(jsonData).forEach((key) => {
      if (jsonData[key].type === 'initials' || jsonData[key].type === 'sign') {
        jsonData[key].value.text = `${lastName} ${firstName} ${fatherName}`
      }
    })
    setConstructorState(jsonData)
  }

  const saveDoc = async () => {
    setIsSaving(true)

    const htmlCode = contentWrapperRef.current
      ? contentWrapperRef.current.outerHTML
      : ''

    try {
      await superAxiosRequest(
        {
          method: 'put',
          link: `${props.apiLinks.contract}/${state.documentId}`,
        },
        {
          html_code: htmlCode,
          json_text: { ...constructorState },
        },
      )

      setTimeout(async () => {
        try {
          const res = await superAxiosRequest({
            method: 'get',
            link: `${props.apiLinks.contract}/${state.documentId}`,
          })

          if (res.data) {
            setQrData(res.data)
            setIsSigningModalOpen(true)
          }
        } catch (err) {
          console.error('Ошибка при получении данных для QR:', err)
        } finally {
          setIsSaving(false)
        }
      }, 20000)
    } catch (err) {
      console.error('Ошибка сохранения документа:', err)
      setIsSaving(false)
    }
  }

  const checkEmail = (email) => {
    return email
      ? { value: false }
      : { value: true, massage: 'В профиле не указан email' }
  }

  useEffect(() => {
    let newComponentState = {
      sendCode: false,
      confirmCode: false,
      success: true,
      isMyDocs: false,
    }

    switch (props.match.params.pageType) {
      case 'contract':
        superAxiosRequest({
          method: 'get',
          link: `${props.apiLinks.contract}/${id}`,
        }).then((res) => {
          if (!res.data[props.confirmedField]) {
            newComponentState = {
              localStorageData: JSON.parse(localStorage.getItem('signedDocs')),
              error: { ...checkEmail(data.user_data.email) },
              documentId: res.data.id,
            }
          }
          if (Object.keys(res.data.json_text).length > 0) {
            setConstructorState(res.data.json_text)
          } else {
            superAxiosRequest({
              method: 'get',
              link: `${props.apiLinks.template}/${res.data[props.templateField]}`,
            }).then((res) => {
              uploadJson(res.data.json_text)
            })
          }
          newComponentState.isMyDocs =
            res.data[props.userField] === data.user_data.profile.id
          setState({ ...state, ...newComponentState })
        })
        break

      case 'template':
        superAxiosRequest({
          method: 'get',
          link: `${props.apiLinks.template}/${id}`,
        }).then((res) => {
          uploadJson(res.data.json_text)
          setState({ ...state, ...newComponentState })
        })
        break

      case 'print':
        superAxiosRequest({
          method: 'get',
          link: `${props.apiLinks.contract}/${id}`,
        }).then((res) => {
          if (!res.data[props.confirmedField]) {
            newComponentState = {
              localStorageData: JSON.parse(localStorage.getItem('signedDocs')),
              error: { ...checkEmail(data.user_data.email) },
              documentId: res.data.id,
            }
          }
          if (Object.keys(res.data.json_text).length > 0) {
            setConstructorState(res.data.json_text)
            setTimeout(() => {
              window.print()
              history.push(`${props.baseLink}/all-requests`)
            }, 1000)
          } else {
            superAxiosRequest({
              method: 'get',
              link: `${props.apiLinks.template}/${res.data[props.templateField]}`,
            }).then((res) => {
              uploadJson(res.data.json_text)
              setTimeout(() => {
                window.print()
                history.push(`${props.baseLink}/all-requests`)
              }, 1000)
            })
          }
          setState({ ...state, ...newComponentState })
        })
        break

      case 'template-print':
        superAxiosRequest({
          method: 'get',
          link: `${props.apiLinks.template}/${id}`,
        }).then((res) => {
          uploadJson(res.data.json_text)
          setState({ ...state, ...newComponentState })
          setTimeout(() => {
            window.print()
            history.push(`${props.baseLink}/template-list`)
          }, 1000)
        })
        break

      default:
        break
    }
  }, [id])

  const getQrImageSrc = (qrCodeData) => {
    if (!qrCodeData) return ''

    if (qrCodeData.startsWith('data:image')) {
      return qrCodeData
    }

    return `data:image/png;base64,${qrCodeData}`
  }

  return (
    <div>
      <div className={styles.notPrint}>
        <ContentHeader
          title={`Подписание договора: ${data.user_data.profile.full_name}`}
        />
      </div>

      <div className={`${styles.container} ${styles.notPrint}`}>
        <div className={styles.content}>
          <div className={styles.content__wrapper} ref={contentWrapperRef}>
            <div className={styles.list}>
              <DocsCreator
                docsCreatorData={constructorState}
                setDocsCreatorData={setConstructorState}
                mode='view'
              />
            </div>
          </div>
        </div>

        {!state.success && state.isMyDocs && (
          <button
            onClick={saveDoc}
            disabled={isSaving}
            style={{
              opacity: isSaving ? 0.7 : 1,
              cursor: isSaving ? 'not-allowed' : 'pointer',
            }}
          >
            {isSaving ? 'Сохранение и подготовка...' : 'Отправить на подписание'}
          </button>
        )}
      </div>

      <div className={`${styles.list} ${styles.print}`}>
        <DocsCreator docsCreatorData={constructorState} mode='view' />
      </div>

      {/* Модальное окно */}
      {isSigningModalOpen && qrData && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <button
              className={styles.modalCloseBtn}
              onClick={() => setIsSigningModalOpen(false)}
            >
              &times;
            </button>

            <h3 className={styles.modalTitle}>Подписание документа</h3>

            <div className={styles.modalColumns}>
              {/* Левая колонка: QR код и ссылка */}
              {qrData.qr_code && (
                <div className={styles.qrColumn}>
                  <div className={styles.qr}>
                    <img
                      src={getQrImageSrc(qrData.qr_code)}
                      alt='QR Code для подписания'
                      style={{
                        maxWidth: '250px',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        padding: '10px',
                        marginBottom: '15px',
                        backgroundColor: '#fff',
                      }}
                    />

                    {qrData.qr_link && (
                      <div
                        style={{
                          wordBreak: 'break-all',
                          fontSize: '13px',
                          textAlign: 'center',
                        }}
                      >
                        <p
                          style={{
                            marginBottom: '5px',
                            color: '#666',
                            fontWeight: '500',
                          }}
                        >
                          Или перейдите по ссылке:
                        </p>
                        <a
                          href={qrData.qr_link}
                          target='_blank'
                          rel='noreferrer'
                          style={{
                            color: '#007bff',
                            textDecoration: 'underline',
                          }}
                        >
                          {qrData.qr_link}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* Правая колонка: Блок подписания */}
              <div className={styles.signingColumn}>
                <SigningBlock
                  documentTemplateId={id}
                  docsData={{
                    ...state,
                    isMyDocs: true,
                    documentId: state.documentId,
                  }}
                  userData={data.user_data}
                  json_text={constructorState}
                  apiLink={props.apiLinks.contract}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DocsViewer
